import React from 'react';
import PropTypes from 'prop-types';

import { Input } from '../../containers/Form';
import Strings from '../../Strings';

const addressFieldRows = [
  [
    { key: 'street', label: Strings.streetAddress, required: true },
    { key: 'street2', label: Strings.streetAddressLine2, required: false },
  ],
  [
    { key: 'city', label: Strings.esiPatientInfo.city, required: true },
    { key: 'state', label: Strings.esiPatientInfo.state, required: true },
  ],
  [
    { key: 'zip', label: Strings.esiPatientInfo.zip, required: true },
    { key: 'country', label: Strings.esiPatientInfo.country, required: true },
  ],
];

function AddressFields(props) {
  const {
    address,
    onAddressChange,
    isRequired,
    highlightInvalid,
    groupedRows,
    disabled,
    validationErrors,
  } = props;

  const renderField = field => (
    <Input
      key={field.key}
      label={field.label}
      type="text"
      name={field.key}
      id={field.key}
      onChange={e => onAddressChange(field.key, e.target.value)}
      value={address?.[field.key]}
      isRequired={field.required ? isRequired : false}
      highlightInvalid={highlightInvalid}
      disabled={disabled}
      errorsForTooltip={validationErrors?.find(v => v.property === field.key)?.errors || []}
    />
  );

  if (!groupedRows) {
    return (
      <>
        {addressFieldRows.flat().map(renderField)}
      </>
    );
  }

  return (
    <>
      {addressFieldRows.map((row, idx) => (
        <div className="horizontal-flex" key={idx}>
          {row.map(renderField)}
        </div>
      ))}
    </>
  );
}

AddressFields.propTypes = {
  address: PropTypes.shape({
    street: PropTypes.string,
    street2: PropTypes.string,
    city: PropTypes.string,
    state: PropTypes.string,
    zip: PropTypes.string,
    country: PropTypes.string,
  }),
  validationErrors: PropTypes.arrayOf(
    PropTypes.shape({
      property: PropTypes.string,
      errors: PropTypes.arrayOf(PropTypes.string),
    })
  ),
  onAddressChange: PropTypes.func.isRequired,
  isRequired: PropTypes.bool,
  highlightInvalid: PropTypes.bool,
  groupedRows: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default AddressFields;